import pathOr from 'ramda/src/pathOr';
import { formatKwValues, formatNumberString } from '../utils';
import hasPath from 'ramda/src/hasPath';
import { ValueType } from '../types';
import { createTemperatureValue, getUserPreferenceTemperatureUnit, } from './temperature';
export const normalizeCommentFromApiResponse = (commentPayload) => ({
    comment: commentPayload.comment,
    commentType: commentPayload.commentType && commentPayload.commentType.key,
    createdAt: commentPayload.createdAt,
    from: commentPayload.from,
    id: commentPayload.id,
    orgId: commentPayload.orgId,
    resourceId: commentPayload.resourceId,
    resourceType: commentPayload.resourceType && commentPayload.resourceType.key,
    siteId: commentPayload.siteId,
    subComments: commentPayload.subComments,
    to: commentPayload.to,
    updatedAt: commentPayload.updatedAt,
    userId: commentPayload.userId,
    value: commentPayload.value,
    valueType: commentPayload.valueType && commentPayload.valueType.key,
    valueSubtype: commentPayload.valueSubtype && commentPayload.valueSubtype.key,
});
export const determinePopupXCoordinate = (mouseXPosition, chartContainerRef) => {
    const chartContainerWidth = pathOr(undefined, ['current', 'clientWidth'], chartContainerRef);
    //320px is the popup width, 25px is the offset px
    if (chartContainerWidth && chartContainerWidth < mouseXPosition + 25 + 320) {
        return Math.max(5, mouseXPosition - 320 - 25);
    }
    return mouseXPosition + 25;
};
export const formattedCommentValueString = (value, valueType, currentUser, countryCode) => {
    switch (valueType) {
        case ValueType.BINARY: {
            return value === '1' ? 'Open' : 'Closed';
        }
        case ValueType.HUMIDITY: {
            return `${formatNumberString(Number(value), {
                unit: '%',
                countryCode,
                numDecimals: 1,
            })}`;
        }
        case ValueType.TEMPERATURE: {
            const unit = getUserPreferenceTemperatureUnit(currentUser);
            return formatNumberString(createTemperatureValue(+value, currentUser), {
                numDecimals: 1,
                unit,
                countryCode,
            });
        }
        case ValueType.ENERGY: {
            return `${formatKwValues(Number(value), countryCode)}`;
        }
        default:
            return value;
    }
};
export const determineCommentValue = (value, valueType, currentUser, useCase) => {
    if (valueType === ValueType.TEMPERATURE) {
        //value from BE is always in C,
        //and will need to convert to F
        // createTemperatureValue helper converts unit
        // to the user's preference
        switch (useCase) {
            case 'forNewCommentPayload':
                return Number(value);
            case 'forDisplayingInChart':
                return createTemperatureValue(Math.round(Number(value) * 10) / 10, currentUser);
        }
    }
    return Number(value);
};
export const determineNewCommentPopupInfo = (e, dataKey, sensorId, valueType, chartContainerRef, currentUser) => {
    const activePayload = e.activePayload || [];
    //ensure that the payload is not a comment or notification
    const correctPayload = (activePayload.find((p) => {
        let doDataKeysMatch = false;
        if (typeof (dataKey) === 'function') {
            const value = dataKey(p.payload);
            if (value !== undefined)
                doDataKeysMatch = true;
        }
        else {
            doDataKeysMatch =
                p.dataKey === dataKey || p.dataKey === `${parseInt(dataKey)}`;
        }
        return (doDataKeysMatch &&
            !hasPath(['payload', 'commentValue'], p) &&
            !hasPath(['payload', 'notificationValue'], p));
    }) || {}).payload;
    const processedPayload = correctPayload
        ? {
            timestamp: correctPayload.timestamp,
            value: typeof (dataKey) === 'function' ? dataKey(correctPayload) :
                dataKey === 'current' ? correctPayload['value'] :
                    correctPayload[dataKey]
        }
        : undefined;
    if (processedPayload !== undefined && processedPayload.value !== undefined) {
        const popupXCoordinate = determinePopupXCoordinate(e.chartX, chartContainerRef);
        const resourceValue = determineCommentValue(processedPayload.value, valueType, currentUser, 'forNewCommentPayload');
        const dateStringISO = new Date(processedPayload.timestamp).toISOString();
        const payload = {
            resourceId: sensorId,
            value: resourceValue,
            valueType: valueType,
            from: dateStringISO,
            to: dateStringISO,
        };
        return {
            newCommentReferenceDot: {
                x: processedPayload.timestamp,
                y: dataKey === 'current' ? correctPayload.current : processedPayload.value,
            },
            newCommentPopupXCoordinate: popupXCoordinate,
            newCommentPopupPayload: payload,
        };
    }
    return null;
};
